// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__vcME5","errorLogs":"EditorFooter_errorLogs__3iJRh"};